import { useState } from "react";
import { IoIosSend } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { GrPowerReset } from "react-icons/gr";
import Input from '../../design/Input';
import LineStyle from '../../design/LineStyle';
import SearchConainer from './SearchConainer';
import { fetchPostUsers } from "../../../faetures/fetch";
import insertNames from "../../../functions/insertNames";


export default function SearchMain ({setNames, firstName, lastName, setMassage, setClose}) {
    const dataDatalist = {firstName: firstName || '', lastName: lastName || '', firstNameH: '', lastNammeH: '', id: '', passport: '', phone: '', email: ''};
    const dataSelect = {firstName: 2, lastName: 2, firstNameH: 2, lastNameH: 2};
    const [data, setData] = useState(dataDatalist);
    const [select, setSelect] = useState(dataSelect);
    const [selectNumOfResult, setSelectNumOfResult] = useState(15);

    const sendData = () => {
        const dataToSend = {}
        Object.entries(data).map(([key, value]) => {
            value && (dataToSend[key] = [value, select[key]])
        })
        if (Object.keys(dataToSend).length) {
            setMassage({open: true, text: ''});
            fetchPostUsers('searchUser', {data: dataToSend, numOfResult: selectNumOfResult}).then((resolve) => {
                if (resolve && typeof resolve === 'object') {
                    if (Object.keys(resolve).length) {
                        setMassage({open: false, text: ""});
                        setNames(insertNames(resolve));
                    } else {
                        setMassage({open: true, text: "אין תוצאות"});
                    }
                } else if (resolve === 'error') {
                    setMassage({open:true, text: "שגיאה באחד מהנתונים"});
                }
            }).catch(() => {
                setMassage({open: true, text: 'שגיאה בשרת ! נסה בעוד כמה דקות'})
            })
        }
    }

    const resetbutun = () => {
        setData(dataDatalist);
        setSelect(dataSelect);
        setSelectNumOfResult(15);
        setNames({});
    }

    return (
    <div className="SearchMain">
        <div>            
            {
                ['firstName', 'lastName', 'firstNameH', 'lastNameH'].map((value, key) => 
                    <SearchConainer 
                    key={key}
                    text={value === 'firstNameH' ? "שם פרטי" : value === 'lastNameH' ? "שם משפחה" : value}
                    language={value.endsWith('H') ? 'he' : 'en'}
                    textView={`ש.${value.startsWith('first') ? "פ" : "מ"} ${value.endsWith('H') ? "בעברית" : "באנגלית"}`}
                    pattern={value.endsWith('H') ? 'strHe' : 'strEn'}
                    value={data[value]}
                    onChange={(v) => setData({...data, [value]: v})}
                    valueSelect={select[value]}
                    onChangeSelect={(e) => setSelect({...select, [value]: e.target.value})}
                    />
                )
            }
            <LineStyle space={'30'} />

            <p>מ.ז</p>
            <Input 
            myStyle="input3" 
            textView={"תעודת זהות"} 
            value={data.id} 
            onChange= {(v) => setData({...data, id: v})}
            pattern="^[0-9]{1,9}$"
            />
            <p> דרכון </p>
            <Input 
            myStyle="input3" 
            textView={"פספורד"} 
            value={data.passport} 
            onChange= {(v) => setData({...data, passport: v})}
            pattern="passpord"
            /> 
            <p> פלאפון </p>
            <Input 
            myStyle="input3" 
            textView={"פלאפון"} 
            value={data.phone} 
            onChange= {(v) => setData({...data, phone: v})}
            pattern={'phone'}
            /> 
            <p> אמייל </p>
            <Input 
            myStyle="input3" 
            textView={"אמייל"} 
            value={data.email} 
            onChange= {(v) => setData({...data, email: v})}
            pattern={'email'}
            /> 

            <div className="search-button">
                <div onClick={resetbutun}>
                    <GrPowerReset />
                    <p>איפוס</p>
                </div>

                <div onClick={() => setClose(false)}>
                    <IoClose />
                    <p>סגירה</p>
                </div>
            </div>

            <div className='Search-main-select' onClick={sendData}>
                <select 
                className='Search-select' 
                value={selectNumOfResult} 
                onChange={(e) => setSelectNumOfResult(e.target.value)}
                onClick={(event) => event.stopPropagation()}
                >
                    <option value={15}> 15 תוצאות </option>
                    <option value={30}> 30 תוצאות </option>
                    <option value={45}> 45 תוצאות </option>
                    <option value={60}> 60 תוצאות </option>
                    <option value={75}> 75 תוצאות </option>
                    <option value={90}> 90 תוצאות </option>
                    <option value={105}> 105 תוצאות </option>
                    <option value={120}> 120 תוצאות </option>

                </select>

                <IoIosSend 
                className='Search-main-send-icon' 
                />
            </div>
        </div>
    </div>
    )
}